import WebService from "./WebService";

class ElasticSearchService extends WebService {
  reindexAll(pageInfo, callback, failureCallback) {
    const url = this.urlFactory.elasticSearchReindexUrl();
    return this.reindex(url, pageInfo, callback, failureCallback);
  }

  getReindexStatus(dataCallback, failureCallback) {
    const url = this.urlFactory.elasticSearchReindexStatusUrl();
    return this.get(url, dataCallback, undefined, failureCallback);
  }

  reindexOne(entity, pageInfo, callback, failureCallback) {
    const url = this.urlFactory.elasticSearchReindexEntityUrl(entity.id);
    return this.reindex(url, pageInfo, callback, failureCallback);
  }

  getReindexStatusOne(entity, dataCallback, failureCallback) {
    const url = this.urlFactory.elasticSearchReindexEntityStatusUrl(entity.id);
    return this.get(url, dataCallback, undefined, failureCallback);
  }

  reindex(url, pageInfo, callback, failureCallback) {
    if (pageInfo) {
      const urlParams = this.urlFactory.constructPaginationAndFilteringUrlQueries(
        pageInfo,
        undefined,
        false
      );
      url += urlParams ? urlParams : "";
    }
    return this.post(
      url,
      undefined,
      undefined,
      callback,
      failureCallback,
      false,
      null
    );
  }
}
export default ElasticSearchService;
